<template>
  <div id="app">
    <div style="margin-bottom: 40px;">
      <b-form @submit="onSearch" @keyup.enter="onSearch" inline>
        <b-form-input
          ref="search"
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="Reference code or name"
          style="width: 200px;"
        />
        <b-button type="submit" variant="primary">Search</b-button>
        <div style="margin-left: 20px;">{{search_total}} / {{total}} registrations</div>
        <b-icon
          icon="arrow-clockwise"
          font-scale="1"
          style="margin-left: 10px;"
          role="button"
          @click="onReload"
        ></b-icon>
      </b-form>
    </div>

    <b-container>
      <b-row>
        <b-col>
          <b-pagination-nav
            size="sm"
            align="fill"
            v-model="current_page"
            :number-of-pages="total_page"
            base-url="#"
            first-number
            last-number
            @change="onPageChanged"
          ></b-pagination-nav>
        </b-col>
      </b-row>
      <b-row>
        <b-col :key="key" v-for="(record, key) in queriedRecords" col lg="3">
          <b-card tag="article" class="mb-3" :title="record.ref_code">
            <b-card-text>{{record.name}}</b-card-text>
            <b-card-text style="font-size: 14px;">{{record.submitted_at}}</b-card-text>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination-nav
            size="sm"
            align="fill"
            v-model="current_page"
            :number-of-pages="total_page"
            base-url="#"
            first-number
            last-number
            @change="onPageChanged"
          ></b-pagination-nav>
        </b-col>
      </b-row>
    </b-container>

    <b-modal ref="modal-progress" block hide-footer="true" hide-header="true">
      <p class="my-4">Wait a minute...... Do u enjoy Wonderfruit???</p>
    </b-modal>
  </div>
</template>

<script>
import firebase from "firebase";

const config = {
  apiKey: "AIzaSyDbqNUpGAdShZ0U1xtKj42U6wHaXvjm4d4",
  authDomain: "eventpop-registration.firebaseapp.com",
  databaseURL: "https://wdf2019-regis.firebaseio.com",
  projectId: "eventpop-registration",
  appId: "1:639353211328:web:924180621cfb0ab79de025",
};

firebase.initializeApp(config);

let database = firebase.database();
let recordsRef = database.ref("/records");

export default {
  name: "app",
  data() {
    return {
      records: {},
      queriedRecords: {},
      total: 0,
      search_total: 0,
      current_page: 1,
      total_page: 1,
      MAX_PAGE: 100,
    };
  },
  created() {
    firebase
      .auth()
      .signInWithEmailAndPassword(
        "hosting@eventpop.me",
        "FTHBVDZCev6bdGaSmMcAS4mZpfE834Se"
      )
      .catch((error) => {
        console.log(error);
      });
  },
  mounted() {
    this.$refs["modal-progress"].show();

    recordsRef.once("value", (snapshot) => {
      this.records = [];

      snapshot.forEach((data) => {
        let record = data.val();
        record.ref_code = data.key;
        record.submitted_at = new Date(record.submitted_at).toLocaleString(
          "zh-TW"
        );

        this.records.push(record);
      });

      this.queriedRecords = this.records.slice(0, this.MAX_PAGE);

      this.total = this.records.length;
      this.search_total = this.total;
      this.total_page = this.total / this.MAX_PAGE;

      this.$refs["modal-progress"].hide();
    });
  },
  methods: {
    onSearch(evt) {
      evt.preventDefault();

      let search = this.$refs.search.localValue.toLowerCase();

      let result = this.records.filter((record) => {
        return (
          record.ref_code.toLowerCase().includes(search) ||
          record.name.toLowerCase().includes(search)
        );
      });

      this.current_page = 1;
      this.total_page = result.length / this.MAX_PAGE;
      this.queriedRecords = result.slice(0, this.MAX_PAGE);

      this.search_total = result.length;
    },
    onPageChanged(page) {
      let search = this.$refs.search.localValue.toLowerCase();

      let result = this.records.filter((record) => {
        return (
          record.ref_code.toLowerCase().includes(search) ||
          record.name.toLowerCase().includes(search)
        );
      });

      let start = (page - 1) * this.MAX_PAGE;
      this.queriedRecords = result.slice(start, start + this.MAX_PAGE);
    },
    onReload() {
      location.reload();
    },
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 60px;
}
</style>
